import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import type { RouteComponentProps } from 'react-router';

import ResolverIframe from '@swf/components/Iframe/ResolverIframe';
import RawButton from '@swf/components/StarsButton/RawButton';
import StarsButton from '@swf/components/StarsButton/StarsButton';
import Body from '@swf/components/StarsModal/components/Body';
import CloseButton from '@swf/components/StarsModal/components/CloseButton';
import Header from '@swf/components/StarsModal/components/Header/Header';
import Translation from '@swf/components/Translation/Translation';
import type { Dispatch } from '@swf/core/store';
import { select } from '@swf/core/store';
import { RaceType } from '@swf/core/types/CasinoRaces';

import {
  TXTWCL_Accept_Terms_X_Conditions,
  TXTWCL_Terms_and_Conditions
} from './CasinoHelp.messages.json';
import styles from './CasinoHelp.scss';

const CasinoHelp: React.FC<
  RouteComponentProps<
    object,
    object,
    { title: string; buttonText: string; helpPressed: boolean; helpType: RaceType }
  >
> = ({
  location: {
    state: { title, buttonText, helpPressed, helpType }
  }
}) => {
  const liveCasinoTermsAccepted = useSelector(select.casino.liveRacesTermsAccepted);
  const showUK = useSelector(select.casino.UKAcceptanceRequired);
  const showLive = !liveCasinoTermsAccepted;
  const showHelp = helpPressed && !showUK;
  const { casino, modal } = useDispatch<Dispatch>();
  return (
    <>
      <Header>
        {showHelp ? title : <Translation {...TXTWCL_Terms_and_Conditions} />}
        <CloseButton />
      </Header>
      <Body className={styles.body}>
        <ResolverIframe
          tag={
            showLive && helpType === RaceType.LIVE && !showHelp
              ? 'prm_casino_live_races_help'
              : 'prm_casino_races_ingame'
          }
          className={styles.helpFrame}
          scrolling="yes"
        />
        {!showHelp && (showUK || showLive) && (
          <StarsButton
            onClick={
              showUK && helpType === RaceType.FEATURED
                ? () => casino.acceptUK()
                : () => casino.acceptLiveRacesTerms()
            }
            block
            translation={TXTWCL_Accept_Terms_X_Conditions}
          />
        )}
        {showHelp && buttonText && (
          <RawButton onClick={() => modal.close()} block>
            {buttonText}
          </RawButton>
        )}
      </Body>
    </>
  );
};

export default CasinoHelp;
